import { gql, useMutation } from '@apollo/client';
import { GET_USER } from './useUserQuery';
import { GetDpoInfo } from '../dpo/useDpoInfoQuery';

const UPLOAD_DPO_AVATAR = gql`
  mutation uploadDpoAvatar($file: Upload!, $size: Int!, $userId: String!) {
    uploadDpoAvatar(file: $file, size: $size, userId: $userId) {
      id
      dpoAvatarUrl
    }
  }
`;

export const useUserUploadDpoAvatarMutation = () => {
  return useMutation(UPLOAD_DPO_AVATAR, {
    context: {
      headers: {
        'apollo-require-preflight': 'true',
      },
    },
    refetchQueries: [GET_USER, GetDpoInfo],
  });
};
